import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../../components/forms/input'
import MyTextArea from '../../../components/forms/textArea'

const AddExerciseRecipe = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '食谱名称不能为空'})
      return false
    }

    axios.post('/admin/user/exercise_recipe/add', {
      name: formValue.name,
      goal: formValue.goal,
      user_oid: props.data.userOid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('添加成功！')
          props.getExerciseRecipeData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <Modal
      destroyOnClose={true}
      title="添加运动食谱"
      width='500px'
      open={props.isOpen}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key='cancel' onClick={handleCancel}>取消</Button>,
        <Button key='submit' onClick={handleNext}>提交并添加下一条</Button>,
        <Button key='isOk' type="primary" onClick={handleOk}>添加</Button>
      ]}>

      <MyInput
        id="name"
        required
        autoFocus
        maxLength={64}
        label='食谱名称'
        placeholder='请输入食谱名称'
        value={formValue.name}
        onChange={setFormValue}
        errorMsg={errorMsg.nameEmpty}
      />

      <MyTextArea
        id="goal"
        label='食谱目标'
        minRows={3}
        placeholder='请输入食谱目标'
        value={formValue.goal}
        onChange={setFormValue}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default AddExerciseRecipe
